<template>
  <div>
    <app-spinner v-if="!is_loaded"/>
    <template v-else>
      <app-cells><h1 class="title">Birthdays</h1></app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
      >
        <template #h__group.name><div class="table-default__left">Group name</div></template>
        <template #h__client.full_name><div class="table-default__left">Full name</div></template>
        <template #h__client.food_preference><div class="table-default__left">Diet</div></template>
        <template #client.dob="{ row }">
          {{ dateFormat(row.client.dob) }}
        </template>
        <template #client.full_name="{ row }">
          <div class="table-default__left table-default__left--photo">
            <template v-if="row.client.gender">
              <img v-if="row.client.gender === 'male'" src="@/assets/img/male-icon.svg" alt="">
              <img v-if="row.client.gender === 'female'" src="@/assets/img/female-icon.svg" alt="">
            </template>
            <img v-else src="@/assets/img/gender-plug-icon.svg" alt="">
            <router-link
              :to="{ name: 'clients-detail', params: { id: row.client.id } }"
              class="table-default__link-border"
            >
              {{ row.client.full_name }}
            </router-link>
            <span v-if="row.age">({{ row.age }} y.o.)</span>
          </div>
        </template>
        <template #client.food_preference="{ row }">
          <div class="table-default__controls table-default__left">
            {{ row.client.food_preference || '-' }}
          </div>
        </template>
        <template #client.food_preferences="{ row }">
          <div class="table-default__controls">
            <span
              v-tooltip="{content: row.client.food_allergy, placement: 'top-start', offset: 10}"
              class="table-default__activity table-default__activity--food-allergy"
              :class="{'table-default__activity--active': row.client.food_allergy}"
            ></span>
            <span
              class="table-default__activity table-default__activity--gf"
              :class="{'table-default__activity--active': row.client.food_gluten_free}"
            ></span>
            <span
              class="table-default__activity table-default__activity--lf"
              :class="{'table-default__activity--active': row.client.food_lactose_free}"
            ></span>
          </div>
        </template>
        <template #group.name="{ row }">
          <div class="table-default__left">
            <router-link
              :to="{ name: 'climbing-groups-detail-clients', params: { id: row.group.id } }"
              class="table-default__link-border"
            >
              {{ row.group.name }}
            </router-link>
          </div>
        </template>
        <template #group.tour_start="{ row }">
          {{ dateFormat(row.group.tour_start) }}
        </template>
        <template #group.tour_end="{ row }">
          {{ dateFormat(row.group.tour_end) }}
        </template>
        <template #group.chief_guide="{ row }">
          {{ row.group.chief_guide || '-' }}
        </template>
        <template #group.camp="{ row }">
          {{ row.camp || '-' }}
        </template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import { getClimbingGroupBirthdays } from '@/http'
import { format, parse, parseISO } from 'date-fns'

export default {
  name: 'ClimbingBirthdays',
  data() {
    return {
      is_loaded: false,
      table: {
        items: [],
        columns: [
          'client.dob',
          'client.full_name',
          'client.food_preference',
          'client.food_preferences',
          'group.name',
          'group.tour_start',
          'group.tour_end',
          'group.chief_guide',
          'group.camp',
        ],
        options: {
          headings: {
            'client.dob': 'Dob',
            'client.full_name': 'Full name',
            'client.food_preference': 'Diet',
            'client.food_preferences': 'Preferences',
            'group.name': 'Group name',
            'group.tour_start': 'Tour start',
            'group.tour_end': 'Tour finish',
            'group.chief_guide': 'Guide name',
            'group.camp': 'Camp'
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      getClimbingGroupBirthdays()
        .then(response => {
          this.table.items = response.data
          this.is_loaded = true
        })
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : ''
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : ''
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>
